export default __webpack_public_path__ + "static/media/allCards.67f757c3.svg";